import root from '../root';
import urlParamsToObject from './urlParamsToObject';

/**
 * @public
 * Gets the value of a specific key from the URL search.
 *
 * @see https://gist.github.com/jherax/e6ecb05aa35eb0219525
 *
 * @param  {String} url: (optional) URL from where extract the search parameters
 * @param  {String} key: specific parameter in the url-search to extract
 * @return {Primitive}
 */
export default function urlParameter(...args) {
  let url = root.location.href,
    key = args[0];

  if (args.length > 1) {
    [url, key] = args;
  }

  const params = urlParamsToObject(url);

  return params[key] || params[`p.${key}`] || '';
}
